<template>
	<div :id="`block-${$vnode.key}`" class="c-block-list-infogram">
		<LongReadTarget
			v-if="title && showTitleInToc"
			class="relative"
			:link-to-toc="{
				name: `Spring til &quot;${title}&quot; i indholdsfortegnelsen`,
				attrs: {
					'data-focus-ignore': true,
				},
			}"
			:container-id="`block-${$vnode.key}`"
			:title="title"
		/>
		<div
			class="c-block-list-infogram__embed max-w-full"
			:class="[
				{
					'w-full': !turnOffScale,
				},
				'infogram-embed',
			]"
			:data-id="infogramId"
			data-type="interactive"
			:data-title="title"
		></div>
	</div>
</template>

<script>
import { LongReadTarget } from '~/components/shared/LongRead';

export default {
	name: 'BlockListInfogram',

	components: {
		LongReadTarget,
	},

	inheritAttrs: false,

	props: {
		title: String,
		showTitleInToc: Boolean,

		infogramId: String,
		turnOffScale: Boolean,
	},

	beforeMount() {
		this.$nextTick(() => {
			this.infogramAsync(
				document,
				'script',
				'infogram-async',
				'https://e.infogram.com/js/dist/embed-loader-min.js'
			);
		});
	},

	methods: {
		infogramAsync(e, t, n, s) {
			const i = 'InfogramEmbeds';
			const o = e.getElementsByTagName(t)[0];
			const d = /^http:/.test(e.location) ? 'http:' : 'https:';

			if (/^\/{2}/.test(s)) {
				s = d + s;
			}

			if (window[i] && window[i].initialized) {
				window[i].process?.();
			} else if (!e.getElementById(n)) {
				const a = e.createElement(t);
				a.async = 1;
				a.id = n;
				a.src = s;
				o.parentNode.insertBefore(a, o);
			}
		},
	},
};
</script>
